import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useToasts } from 'react-toast-notifications';
import SInputComponent from '../../components/s-input/s-input.component';
import { utils } from '../../_helpers';
import queryString from 'query-string';
import { authService } from '../../services/auth.service';
import { useF5PageCheck } from '../../hooks/check-f5.hook';
import { ErrorMessageEnum } from '../../enums/app.enum';

const ResetPasswordPage = (props: any) => {
  const { clearErrors, control, handleSubmit, setError, getValues, formState: { errors } } = useForm();
  const { addToast } = useToasts();
  const { token } = queryString.parse(props.location.search);
  useF5PageCheck();
  const [checkingCode, setCheckingCode] = useState(true);

  useEffect(() => {
    authService.verifyCode({ token }).then(res => {
      setCheckingCode(false);
    }).catch(err => {
      addToast(err.response.data?.error || 'Invalid token', { appearance: 'error' })
      props.history.replace('/')
    })
  }, []);

  const onSubmit = (formData: any) => {
    const data = {
      password: formData.password,
      token: token
    }

    authService.resetPassword(data).then(res => {
      addToast(ErrorMessageEnum.passwordChangeSuccess, { appearance: 'success' })
      props.history.replace('/')
    }).catch(err => {
      clearErrors()
      setError('password', { type: 'manual', message: err.response.data?.error })
    })

  }

  return (
    <Container>
      {
        !checkingCode && (
          <Row>
            <Col>
              {token ?
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <div className="wapper-form py-4 px-3 mx-auto" style={{ padding: 0, maxWidth: '420px' }}>
                    <div className='border-bottom text-15 font-weight-bold text-center letter-86 py-3'>PASSWORD MANAGEMENT</div>
                    <Row>
                      <Col className='px-5'>
                        <label className='text-15 font-weight-bold letter-86 mt-3'>New Password</label>
                        <SInputComponent name="password" type='password' placeholder="******" control={control} error={errors.password} className='mt-2'
                          rules={{
                            required: { value: true, message: ErrorMessageEnum.requiredFieldMessage },
                            validate: (val: string) => {
                              return !!utils.validPassword(val) || 'At least 8 characters, must have uppercase and lowercase letters and numbers'
                            }
                          }}
                        />
                        <label className='text-15 font-weight-bold letter-86 mt-3'>Re-enter New Password</label>
                        <SInputComponent name="repassword" type='password' placeholder="******" control={control} error={errors.repassword} className='mt-2'
                          rules={{
                            required: { value: true, message: ErrorMessageEnum.requiredFieldMessage },
                            validate: (val: string) => {
                              const { password } = getValues()
                              return password === val || 'Password did not match'
                            }
                          }}
                        />
                        <div className='letter-86 text-graya6 text-14 text-left mt-2 px-2 mb-4'>*At least 8 characters, must have uppercase and lowercase letters and numbers.</div>
                      </Col>
                    </Row>

                  </div>
                  <Row className='justify-content-center mt-4 mb-8'>
                    <Button type='submit' className="font-weight-bold py-2 px-4 radius-8" variant="dark">CHANGE PASSWORD</Button>
                  </Row>
                </Form>
                :
                <div className="wapper-form py-4 px-3 mx-auto" style={{ padding: 0, maxWidth: '420px', marginBottom: '30px' }}>
                  <div className='border-bottom text-15 font-weight-bold text-center letter-86 py-3'>INVALID TOKEN</div>
                </div>
              }
            </Col>
          </Row>
        )
      }
      {
        checkingCode && <p className='text-14'>Checking token</p>
      }
    </Container>
  )
}

export default React.memo(ResetPasswordPage)
